import React, { useEffect, useCallback, useState} from 'react';
import TracksOverview from "components/sidebar/TracksOverview.js"
import {MULTI_FREEZE, SAMPLER, INSTRUMENT, INSTRUMENT_RACK} from 'constants/track-types.js';
import {SAMPLED_INSTRUMENT, MULTI_SYNTH} from 'constants/instrument-types.js';
import {MODE_TO_HEIGHT, WAVEFORM, PIANO_ROLL, INFO} from 'constants/arrangement-modes.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {
    setShowPianoRoll,
    setArrangementBottomMode,
} from 'actions/index.js';

const colors = new Colors();

const Modes = ({track, setBottomMode, bottomMode, isFrozen, setShowPianoRoll}) => { 
    const [showQuickTracks, setShowQuickTracks] = useState(false);

    let hasSampler = track.getTrackType() === SAMPLER ||
        track.getTrackType() === MULTI_FREEZE ||
        isFrozen;
    let hasPiano = track.getTrackType() !== MULTI_FREEZE;
    let hasInfo = track.getTrackType() === SAMPLER;
    let t = track;
    if (track.getTrackType() === INSTRUMENT_RACK &&
        track.tracks.length > 0){
        t = track.tracks[0].track;
    }

    if (t.getTrackType() === INSTRUMENT && t.instrument) {
        if (t.instrument.getInstrumentType() === SAMPLED_INSTRUMENT ||
            t.instrument.getInstrumentType() === MULTI_SYNTH
           ) {
            hasInfo = true;
        }
    }
    if (t.isFrozen) {
        hasInfo = false;
    }

    useEffect(() => {
        if (isFrozen) {
            setBottomMode(WAVEFORM);
        }
    }, [isFrozen]);

    let nameStyle = {
        color: colors.getColorForTrack(track)
    };

    return (
        <div
          onMouseLeave={() => setShowQuickTracks(false)}
          className="modes">
          <div
            onClick={() => setShowQuickTracks(!showQuickTracks)}
            style={nameStyle} className={showQuickTracks ? "toolbar-track-name show" : "toolbar-track-name"}>
            {truncate(track.presetName || track.getName())}
            {showQuickTracks ?
             <TracksOverview showName={true} mode={bottomMode} sequencerEngine={track.sequencerEngine}/> : ''}
          </div>
          {hasInfo ? 
           <Mode track={track} option={INFO}
                 selectedOption={bottomMode}
                 name={track.getTrackType() === INSTRUMENT ? "Presets" : "Info"}
                 setBottomMode={setBottomMode}/> : ''}
          {hasSampler ? 
           <Mode track={track} option={WAVEFORM} selectedOption={bottomMode}
                 name="Waveform" setBottomMode={setBottomMode}/>
           : ''}
          {hasPiano ? 
           <Mode track={track} option={PIANO_ROLL} selectedOption={bottomMode}
                 name="Piano" setBottomMode={setBottomMode}/> : ''}
        </div>);
}

const Mode = ({option, name, selectedOption, setBottomMode, track}) => {
    let className = "mode";
    if (option === selectedOption) {
        className += " selected";
    }

    let style = {
    };
    if (selectedOption === option) {
        style.borderBottomWidth = 4;
        style.borderBottomStyle = 'solid';
        style.borderBottomColor = colors.getColorForTrack(track);
    } else {
    }

    return (
        <div
          style={style}
          onClick={() => setBottomMode(option)}
          className={className}>
          {name}
        </div>
    );
};

const truncate = (name) => {
    if (name.length > 40) {
        return name.slice(0, 40) + '...';
    }
    return name;
};

const mapStateToProps = (state, props) => {
  return {
      bottomMode: state.arrangement.bottomMode,
      isFrozen: props.track && props.track.isFrozen
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setBottomMode: (bottomMode) =>
          dispatch(setArrangementBottomMode(bottomMode)),
      setShowPianoRoll: (show) =>
          dispatch(setShowPianoRoll(show)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modes);
